import { useState } from "react";
// import useForm from '../../../../hooks/useForm';
import { Modal, Button } from '@prosolve/common-components-ui'
import { getFileUploadImageTypesOnly } from "../../../../utils";
import FileUpload from '../../../sharedComponents/FileUpload';
import useDataImages from '../../../../dataHooks/useDataImages';
// import useDataAttendees from "../../../../dataHooks/useDataAttendees";

export default ({
  eventId,
  onClose,
  onSuccess,
}) => {

  const {
    uploadImages
  } = useDataImages();

  const [files, setFiles] = useState([]);
  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (files && files.length > 0) {
      setIsBusy(true)
      try {
        await uploadImages(eventId, files)
      } catch (e) {
        console.log(e)
      }
      setIsBusy(false)
      onSuccess()
    }
  }

  const onFilesChanged = (filesUpdated = []) => {
    setFiles(filesUpdated)
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy || files.length < 1}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title='Upload Images' isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <FileUpload
          allowedFileTypes={getFileUploadImageTypesOnly()}
          onFilesChanged={onFilesChanged}
        />
      </div>
    </Modal>
  )
}